import { v4 as uuidv4 } from "uuid";
export const state = {
  reportListArray: [],
  customFieldTypes:[]
};

export const mutations = {
  SET_ARRAY(state, reportListArray) {
    state.reportListArray = reportListArray;
  },
  SET_CUSTOMFIELDSTYPE(state,fieldlist){
    state.customFieldTypes = fieldlist
  },
  ADD_ITEM(state, newItem) {
    state.reportListArray.push(newItem);
  },
  DELETE_ITEM(state, dataId) {
    state.reportListArray.splice(dataId, 1);
  },
  UPDATE_ITEM(state, { index, updatedItem }) {
    console.log('updatedata',index,updatedItem)
    state.reportListArray[index] = updatedItem;
  }
};

export const actions = {
  setInitialArray({ commit }, model) {
    const arrayWithGuids = model.map((item) => {
      return { dataId: uuidv4(), ...item };
    });
    commit("SET_ARRAY", arrayWithGuids);
  },
  setCustomFieldsType({ commit }, fieldlist) {
    commit("SET_CUSTOMFIELDSTYPE", fieldlist);
  },
  addItem({ commit, state },{newItem,addMode}) {
    if(addMode){
      const initialArray = [...state.reportListArray];
      newItem.Order = initialArray.length || 0;
      newItem.dataId = uuidv4(),
      newItem.ShowInReport=false
      newItem.IsSystemDefined=false
      commit("ADD_ITEM", newItem);
    }else {
      const index = state.reportListArray.findIndex(item => item.Order === newItem.Order);
      commit("UPDATE_ITEM", {index:index,updatedItem:newItem});
    }
  },
  deleteItem({ commit }, dataid) {
    const index = state.reportListArray.findIndex(item => item.dataId === dataid);
    if (index !== -1) {
      commit("DELETE_ITEM", index);
    } else {
      console.error(`Item with dataid ${dataid} not found.`);
    }
  },
  updateItem({ commit }, { index, updatedItem }) {
    commit("UPDATE_ITEM", { index, updatedItem });
  },
};

export const getters = {
    getReportListArray: (state) => state.reportListArray,
    getCustomFieldsType: (state) => state.customFieldTypes,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
